module.exports = __webpack_public_path__ + "media/src/img/flag_of_kazakhstan-5c1b03d4d1bf93a5118d2afb4ec82abe.svg";